import apiClient from './apiClient';

export const fetchNotifications = async (page = 0, size = 20) => {
  const response = await apiClient.get('/api/notifications', { params: { page, size } });
  return response.data;
};

export const fetchUnreadCount = async () => {
  const response = await apiClient.get('/api/notifications/unread-count');
  return response.data;
};

export const markNotificationRead = async (id) => {
  await apiClient.put(`/api/notifications/${id}/read`);
};

export const markAllNotificationsRead = async () => {
  await apiClient.put('/api/notifications/read-all');
};

export const getNotificationPreferences = async () => {
  const response = await apiClient.get('/api/notifications/preferences');
  return response.data;
};

export const updateNotificationPreferences = async (preferences) => {
  const response = await apiClient.put('/api/notifications/preferences', preferences);
  return response.data;
};
